import { AudienceCategoryItem, AudiencePlatformItem, CountryItem } from "@digiseg-labs/api-client";

export type CountryState = {
  countries?: CountryItem[];
  setCountry?: (country: CountryItem | undefined) => void;
  country?: CountryItem | undefined;
  onCountryChange?: (country: CountryItem | undefined) => void;
  onOpenCountrySelector?: () => void;
};

export type PlatformState = {
  platforms?: AudiencePlatformItem[];
  setPlatform?: (platform: AudiencePlatformItem | undefined) => void;
  platform?: AudiencePlatformItem | undefined;
  onPlatformChange?: (platform: AudiencePlatformItem | undefined) => void;
};

export type SearchState = {
  searchQuery?: string;
  onSearchChange?: (value: string) => void;
};

export type LayoutState = {
  isCompact?: boolean;
  isMedium?: boolean;
};

export type CategoryState = {
  activeCategoryCode?: string | null;
  openAudienceCode?: string | null;
  activeCategory?: AudienceCategoryItem | undefined;
  onCategorySelect?: (categoryCode: string) => void;
  onClearCategory?: () => void;
  onAudienceModalChange?: (audienceCode: string, open: boolean) => void;
};

export type DialogState = {
  showWelcomeDialog?: boolean;
  onWelcomeDismiss?: () => void;
  onOpenCountrySelector?: () => void;
};

export type PaginationState = {
  pageafter?: string | undefined;
  pagesize?: number;
  rangeTruncated?: boolean;
  onLoadMore?: () => void;
};

export type AudienceViewMode = ('Interest' | 'Demographic')[];

export const otherDSPOptions= [
  { display_name: 'Amazon DSP', code: 'amazon_dsp' }, 
  { display_name: 'DV360',      code: 'dv360'}, 
  { display_name: 'Illumin',    code: 'illumin' }, 
  { display_name: 'Mediasmart', code: 'mediasmart' }, 
  { display_name: 'Nexxen',     code: 'nexxen' }, 
  { display_name: 'Quantcast',  code: 'quantcast' }, 
  { display_name: 'StackAdapt', code: 'stackadapt' }, 
  { display_name: 'Yahoo DSP',  code: 'yahoo_dsp' }
] as const;